import styled from 'styled-components';

/* ----------------------------------
   Connected Services
----------------------------------- */
export const SectionHeading = styled.div`
  max-width: 650px;

  ${({ $center }) =>
    $center &&
    `
      margin-left: auto;
      margin-right: auto;
      text-align: center;
    `}

  h2 {
    margin: var(--space-xs) 0 var(--space-m);

    color: var(--grey7);

    font-size: clamp(2rem, 3.6vw, 3rem);
    line-height: 1.05;
    font-weight: 900;
    letter-spacing: -0.035em;
  }

  > p:not(.eyebrowHeader) {
    margin: 0;

    color: var(--grey4);

    font-size: 1rem;
    line-height: 1.75;
    font-weight: 500;
  }
`;
export const ConnectedServicesSection = styled.section`
  width: 100%;
`;

export const ConnectedServices = styled.div`
  margin-top: var(--space-xxl);

  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--space-l);

  @media screen and (max-width: 1000px) {
    grid-template-columns: 1fr;
  }
`;

export const ConnectedServiceLink = styled.a`
  padding: var(--space-xl);

  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: var(--space-l);

  border: 1px solid var(--grey15);
  border-radius: var(--borderRadius);

  background: var(--cardBackground);

  color: inherit;
  text-decoration: none;

  box-shadow: var(--shadow-sm);

  transition:
    transform 0.2s ease,
    border-color 0.2s ease,
    box-shadow 0.2s ease;

  > div:last-child > span {
    color: var(--orange5);

    font-size: 0.68rem;
    font-weight: 900;
    text-transform: uppercase;
    letter-spacing: 0.1em;
  }

  h3 {
    margin: var(--space-xs) 0 var(--space-s);

    color: var(--grey7);

    font-size: 1.2rem;
    line-height: 1.2;
    font-weight: 900;
  }

  p {
    margin: 0 0 var(--space-l);

    color: var(--grey4);

    font-size: 0.9rem;
    line-height: 1.7;
  }

  strong {
    display: inline-flex;
    align-items: center;
    gap: var(--space-xs);

    color: var(--grey6);

    font-size: 0.85rem;
    font-weight: 900;

    > span {
      transition: transform 0.2s ease;
    }
  }

  &:hover {
    transform: translateY(-3px);

    border-color: var(--yellow3);

    box-shadow: var(--shadow-md);

    strong {
      color: var(--orange5);

      > span {
        transform: translateX(4px);
      }
    }
  }

  @media screen and (max-width: 500px) {
    grid-template-columns: 1fr;
  }
`;

export const ConnectedServiceIcon = styled.div`
  width: 46px;
  height: 46px;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  border-radius: 50%;

  background: var(--yellow1);
  color: var(--orange5);

  font-size: 1.05rem;
`;
